export function resolveBackendBaseUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL?.trim();
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin.replace(/\/$/, '');
    const currentHost = window.location.hostname.toLowerCase().replace(/^www\./, '');
    const platformDomain = (process.env.REACT_APP_PLATFORM_DOMAIN || 'reelisle.com').toLowerCase();
    const adminHost = (process.env.REACT_APP_ADMIN_PORTAL_HOST || `reeladmin.${platformDomain}`).toLowerCase();

    if (currentHost === adminHost) {
      return currentOrigin;
    }
  }
  if (configured) return configured.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin.replace(/\/$/, '');
  return '';
}

export function resolveBackendWsBaseUrl() {
  return resolveBackendBaseUrl()
    .replace(/^https:\/\//, 'wss://')
    .replace(/^http:\/\//, 'ws://');
}

export function buildSessionWsProtocol(token) {
  if (!token) return null;
  try {
    const utf8 = encodeURIComponent(String(token)).replace(/%([0-9A-F]{2})/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    );
    const encoded = window.btoa(utf8).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    return `vl-session.${encoded}`;
  } catch {
    return null;
  }
}
